"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _searchPreviewProductContext = require("./searchPreviewProductContext");
Object.keys(_searchPreviewProductContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _searchPreviewProductContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _searchPreviewProductContext[key];
    }
  });
});
//# sourceMappingURL=index.js.map